export default __webpack_public_path__ + "static/media/36.b4583c11.jpg";